import { EOfferStatusData } from '../../types/offerHistory';
import { EDealType } from '../../types/dealType';
import { IHouseOfferHistoryV4Schema } from '../../repositories/valuation-offer-history/entities/offer_history/HouseOfferHistoryV4Schema';

export const getOfferDeactivatedLabel = (offer: IHouseOfferHistoryV4Schema, dealType: EDealType): string | null => {
  if (offer.status === EOfferStatusData.Deactivated) {
    return dealType === EDealType.Sale ? 'Снято с продажи' : 'Снято с публикации';
  }

  return null;
};
